import { ConditionalRuleConfig } from './types';

export default (rules: ConditionalRuleConfig[]) => {
  return (
    rules.filter((r: ConditionalRuleConfig) => r.utilize === '').length === 0
  );
};
